import { render } from "./UserInfoModal.vue?vue&type=template&id=6f4de10f"
import script from "./UserInfoModal.vue?vue&type=script&lang=js"
export * from "./UserInfoModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\SPNM\\Core\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__